import { Feature } from '@tencent/workbench';
import { SLIDE_ADAPTER } from '@src/framework/workbench/editor-adpater/slide-adapter';
import { IChartLegendShower } from '@tencent/chart-drawer-components/lib/interface';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import ChartBaseDrawerFeature from '@src/framework/workbench/drawer/ui/chart/chart-base-drawer-feature';
import { mappingPositionToILegendPos } from '../utils';
import type { ILegendPos } from '@tencent/chart-drawer-components/lib/interface';
import { ADDITIONAL_POSITION_OPTIONS } from '@tencent/chart-drawer-components';

@Feature({
    name: 'ChartLegendShower',
    adapters: [SLIDE_ADAPTER],
    provide: IChartLegendShower,
})
export class ChartLegendShower extends ChartBaseDrawerFeature implements IChartLegendShower {
    public getPositionSelectOptions(): { key: ILegendPos; content: string }[] {
        return ADDITIONAL_POSITION_OPTIONS;
    }

    public getLegendPosition(): ILegendPos | undefined {
        const model = this.getSelectModel();
        if (model?.type !== UIModelType.CHART) return;
        const legendProperty = model.chartProperty.legend;
        const hasLegendLayout = !!legendProperty?.layout;
        // 有布局的时候不选中位置，参照office
        if (legendProperty && !hasLegendLayout) {
            return mappingPositionToILegendPos(legendProperty.position!);
        }

        return;
    }
}
